import { useContext, useState } from "react";
import { FilterContext } from "../../../context/filterContext";
import { useQuery } from "@apollo/client";

import { GET_ITEMS_WITH_FILTERS } from "../../../queries/queries";
import { ReactComponent as RemoveIcon } from "../../../assets/cross.svg";

import "./catalog-filters-responsive.component.css";
import Loader from "../../common/loader/loader.component";
import { useTranslation } from "react-i18next";
import CatalogSubFilters from "../../catalog/catalog-sub-filters/catalog-sub-filters.component.jsx";
import useLocationFromSession from "../../../shared/hooks/useLocationFromSession";

const _ = require("lodash");

const CatalogFiltersResponsive = ({ toggleDrawer, onSubmitForm }) => {
  const { t } = useTranslation();
  const { searchState } = useContext(FilterContext);

  const { facetValueIds, collectionId, term } = searchState;

  const [facetValues, setFacetValues] = useState(facetValueIds);
  const [filterCollections, setfilterCollections] = useState(collectionId);
  const [filterByTerm, setfilterByTerm] = useState(term);
  const [isFilterChanged, setIsFilterChanged] = useState(false);

  const { queryLocation, isLocationValid } = useLocationFromSession();
  const { loading, error, data } = useQuery(GET_ITEMS_WITH_FILTERS, {
    // skip: !isLocationValid,
    variables: {
      term,
      facetValueIds: [],
      collectionId: filterCollections ? filterCollections["id"] : null,
      groupByProduct: !term.trim(),
      location: isLocationValid ? queryLocation : null,
    },
  });

  if (loading)
    return (
      <div style={{ height: "100vh" }}>
        <Loader color={"#B73232"} size={50} />{" "}
      </div>
    );
  if (error) return `Error! ${error.message}`;

  const updateFacetsValues = (fv) => {
    setIsFilterChanged(true);
    const { __typename } = fv;

    if (__typename === "FacetValue") {
      const newFacetsValues = [...facetValues, fv];
      setFacetValues(newFacetsValues);
    } else if (__typename === "Collection") {
      setfilterCollections(fv);
      setFacetValues([]);
    }
  };

  const removeFacetsValues = (fv) => {
    setIsFilterChanged(true);
    const { __typename } = fv;

    if (__typename === "FacetValue") {
      const facetValueId = fv.id;
      const newFacetsValues = facetValues.filter((fv) => {
        return fv.id !== facetValueId;
      });
      setFacetValues(newFacetsValues);
    } else if (__typename === "Collection") {
      setfilterCollections(null);
      setFacetValues([]);
    } else if (__typename === "search") {
      setfilterByTerm("");
      setfilterCollections(null);
      setFacetValues([]);
    }
  };

  const onSubmit = (e) => {
    const filtersChanged = isFilterChanged
      ? {
        term: filterByTerm,
        facetValueIds: facetValues,
        collectionId: filterCollections,
      }
      : isFilterChanged;
    onSubmitForm(filtersChanged);
    toggleDrawer("bottom", false).call(this);
  };

  const onClearFilters = () => {
    setIsFilterChanged(true);
    setfilterByTerm("");
    setfilterCollections(null);
    setFacetValues([]);
  };

  const filters = _(data?.search?.facetValues)
    .groupBy("facetValue.facet.name")
    .mapValues((v) => _.sortBy(v, "facetValue.name"))
    .toPairs()
    .sortBy(0)
    .fromPairs()
    .value();

  return (
    <div className="CFR">
      <CatalogFiltersResponsiveActions
        toggleDrawer={toggleDrawer}
        onClearFilters={onClearFilters}
      />

      <div style={{ flex: 1 }}>
        <CatalogSubFilters
          updateFacetsValues={updateFacetsValues}
          removeFacetsValues={removeFacetsValues}
          filters={filters}
        />
      </div>
      <button className="CFR__submit--button" onClick={onSubmit}>
        {t("catalog.Apply filters")}
      </button>
    </div>
  );
};

const CatalogFiltersResponsiveActions = ({ toggleDrawer, onClearFilters }) => {
  const { t } = useTranslation();
  return (
    <div className="h5-medium CFR__title">
      <div className="CFR__title__left">
        <span>{t("catalog.Filters")}</span>
        <span className="CFR__title__clear-all" onClick={onClearFilters}>
          <RemoveIcon fill="#80bb34" />
          {t("catalog.Clear All")}
        </span>
      </div>
      <RemoveIcon
        className="CFR__title__right"
        onClick={toggleDrawer("bottom", false)}
      />
    </div>
  );
};

export default CatalogFiltersResponsive;
